import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import axios from "axios";
import { API } from "../config";

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews`).then((res) => setReviews(res.data)).catch(() => {});
  }, []);

  if (!reviews.length) return null;

  return (
    <section id="reviews" data-testid="reviews-section" className="bg-cream py-28 md:py-36 border-t border-ink/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.4em] uppercase text-amberbrand mb-4"
        >
          Reviews
        </motion.p>
        <div className="overflow-hidden mb-16">
          <motion.h2
            initial={{ y: "100%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-5xl md:text-7xl text-ink tracking-tighter"
          >
            What our <span className="italic text-olive">customers say.</span>
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.id || i}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="rounded-3xl border border-ink/10 bg-white/70 p-8 flex flex-col"
            >
              <Quote size={22} className="text-gold/50 mb-5" />
              <blockquote className="font-serif text-xl text-ink/80 leading-relaxed mb-6 flex-1">
                "{r.text}"
              </blockquote>
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: r.rating }).map((_, s) => (
                  <Star key={s} size={14} className="fill-gold text-gold" />
                ))}
              </div>
              <figcaption>
                <p className="text-sm font-medium text-ink">{r.name}{r.city ? ` · ${r.city}` : ""}</p>
                {r.product && (
                  <p className="text-[10px] tracking-[0.25em] uppercase text-ink/40 mt-1">{r.product}</p>
                )}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
